/**
 * Presentación de dinero y fechas del flujo del asesor. Solo formatea y convierte el contrato del back;
 * **no** calcula el plan (AGENTS §16). Todo con `bigint`: nunca `float` para dinero (AGENTS §15).
 */
export function toPesos(value: string | number | bigint | null | undefined): bigint {
  if (value === null || value === undefined) return 0n;
  if (typeof value === 'bigint') return value;
  if (typeof value === 'number') return BigInt(Math.trunc(value));
  const trimmed = value.trim();
  if (!/^-?\d+$/.test(trimmed)) return 0n;
  return BigInt(trimmed);
}

export function formatCOP(value: string | number | bigint | null | undefined): string {
  const pesos = toPesos(value);
  const negative = pesos < 0n;
  const digits = (negative ? -pesos : pesos).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${negative ? '-' : ''}$ ${digits}`;
}

/** `YYYY-MM-DD` (o ISO completo) → `DD/MM/AAAA` sin pasar por `Date` (evita desfases de zona). */
export function formatFecha(iso: string): string {
  const [year, month, day] = iso.slice(0, 10).split('-');
  return year && month && day ? `${day}/${month}/${year}` : iso;
}

/** Fecha local de hoy como `YYYY-MM-DD` (para el valor por defecto de la fecha de separación). */
export function hoyISO(now: Date = new Date()): string {
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * fix-68 · m² en formato colombiano a partir del string exacto del back (`"1234.50"` → `1.234,5 m²`,
 * `"60.00"` → `60 m²`), por cadena: el área nunca pasa por `number`.
 */
export function formatArea(value: string): string {
  const [entero = '0', decimales = ''] = value.trim().split('.');
  const miles = entero.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const fraccion = decimales.replace(/0+$/, '');
  return `${fraccion ? `${miles},${fraccion}` : miles} m²`;
}
